import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsCheckSquare, BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {TableHead} from "../../system/thead";
import React, {useState} from "react";
import TableTdContent from "../../system/tableTdContent";


const TABLE_HEAD = ["#", "عنوان", "توضیحات", "نوع کدمعرفی", "درصد کش بک/ پاداش معرفی", "سهم معرفی کننده", "سهم معرفی شونده", "پیش‌فرض", "وضعیت", "عملیات"];

export function ReferralConfigGrid({referralConfigs, setModalOpen, setSelectedRow, setSortBy, sortType, setSortType}) {

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "عنوان": "title",
    "توضیحات": "description",
    "نوع کدمعرفی": "type",
    "درصد کش بک/ پاداش معرفی": "value",
    "سهم معرفی کننده": "referrer_share",
    "سهم معرفی شونده": "referee_share",
    "پیش‌فرض": "is_default",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "عنوان": true,
    "توضیحات": true,
    "نوع کدمعرفی": true,
    "درصد کش بک/ پاداش معرفی": true,
    "سهم معرفی کننده": true,
    "سهم معرفی شونده": true,
    "پیش‌فرض": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {referralConfigs.map(
          ({
             id,
             title,
             description,
             type,
             value,
             referee_share,
             referrer_share,
             is_default,
             status,
           }, index) => {
            const isLast = index === referralConfigs.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <TableTdContent content={description} length={20}/>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {type === "purchase_cashback" ? "کش بک خرید" : "کش بک خرید"}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(referrer_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(referee_share, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      is_default ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      status === 'enable' ? <BsCheckSquare color={"green"} size={30}/> :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(referralConfigs[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}